export default [
  {
    path: '/bookmark-management',
    name: 'bookmark-management',
    component: () => import('@/views/apps/admins/bookmark-management/BookmarkManagement.vue'),
    meta: {
      resource: 'admin',
      action: 'manage',
    },
  },
]
